import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { hasAuthSession } from '../utils/auth-storage';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = hasAuthSession();
  const location = useLocation();

  if (!isAuthenticated) {
    const intendedPath = location.pathname;
    sessionStorage.setItem('intendedPath', intendedPath);
    return <Navigate to={`/login`} />;
  }

  return children;
};

export default ProtectedRoute;
